import { FC, useCallback } from 'react';
import { Form } from 'react-final-form';
import cn from 'classnames';

import MatchExistingForm from './MatchExistingForm/MatchExistingForm';
import { IMatchExistingFormValues } from './MatchExistingForm/MatchExistingForm.interface';
import { IMatchExistingProps } from './MatchExisting.interface';

const MatchExisting: FC<IMatchExistingProps> = ({
  className,
  confirmDisabled,
  onSelect,
  onSubmit,
  onCancel,
}) => {
  const handleValidate = useCallback((values: IMatchExistingFormValues) => {
    const errors: Partial<Record<keyof IMatchExistingFormValues, string | boolean>> = {};
    if (!values.supplement) errors.supplement = true;
    return errors;
  }, []);

  const handleSubmit = useCallback(
    (values: IMatchExistingFormValues) => {
      if (values.supplement) return onSubmit(values.supplement.id);
    },
    [onSubmit],
  );

  return (
    <div className={cn('match-existing', className)}>
      <Form
        // @ts-ignore because of custom props
        component={MatchExistingForm}
        confirmDisabled={confirmDisabled}
        onSelect={onSelect}
        onCancel={onCancel}
        validate={handleValidate}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default MatchExisting;
